import { ChangeDetectionStrategy, Component, HostBinding, Input, ViewEncapsulation } from '@angular/core';
import { MatFormFieldControl } from '@angular/material/form-field';
import { MatRichTextEditorBaseAbstract } from './mat-rich-text-editor-base';
import { Delta } from 'quill';

// Increasing integer for generating unique ids for mat-rich-text-editor components.
let nextUniqueId = 0;
const elementSelector = 'mat-rich-text-editor';

@Component({
    selector: elementSelector,
    exportAs: 'matRichTextEditor',
    templateUrl: './mat-rich-text-editor.component.html',
    styleUrls: ['./mat-rich-text-editor-dark.component.scss'],
    providers: [{ provide: MatFormFieldControl, useExisting: MatRichTextEditorComponent }],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None
})
export class MatRichTextEditorComponent extends MatRichTextEditorBaseAbstract {
    controlType = elementSelector;
    @Input() override disabled = false;
    @HostBinding() id = `${elementSelector}-${nextUniqueId++}`;
    static override ngAcceptInputType_disabled: boolean | string | null | undefined;
    static override ngAcceptInputType_required: boolean | string | null | undefined;
}
export const matRichTextEditorOptions = {
    formats: ['strike', 'color', 'background'],
    toolbar: [
        ['bold', 'italic', 'underline', 'strike'], // toggled buttons
        ['blockquote'],
        [{ list: 'ordered' }, { list: 'bullet' }],
        [{ size: ['small', false, 'large', 'huge'] }], // custom dropdown
        [{ align: [] }],
        ['clean']
    ],
    clipboard: {
        matchers: [
            [
                Node.ELEMENT_NODE,
                // eslint-disable-next-line space-before-function-paren
                function (node, delta) {
                    return delta.compose(
                        new Delta().retain(delta.length(), {
                            color: false,
                            background: false,
                            strike: false
                        })
                    );
                }
            ]
        ]
    }
};
export const matRichTextEdtorStyleHeight = '200px';
